/* global Modernizr */

export const isBrowser = (): boolean => typeof window === 'object';

// if browsers don't support navigator.onLine always return true. be happy :)
export const isOnline = (): boolean =>
    isBrowser() && 'onLine' in window.navigator ? window.navigator.onLine : true;

export const browserScrollPosition = (): number => {
    if (!isBrowser()) {
        return 0;
    }

    return document.documentElement.scrollTop || document.body.scrollTop;
};

export const isFullscreen = (): boolean => {
    if (!isBrowser()) {
        return false;
    }

    return !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.webkitCurrentFullScreenElement
    );
};

// No need to check for sessionStorage because same browser support as localstorage.
export const supportsLocalStorage = (): boolean => isBrowser() && Modernizr && Modernizr.localstorage;

export const supportsPeformanceApi = (methods = []): boolean => {
    let supports = isBrowser() && window.hasOwnProperty('performance');

    if (supports) {
        supports = methods.some((method) => typeof window.performance[method] !== 'undefined');
    }

    return supports;
};

export const supportsNavigator = (methods = []): boolean => {
    let supports = isBrowser() && window.hasOwnProperty('navigator');

    if (supports) {
        supports = methods.some((method) => typeof window.navigator[method] !== 'undefined');
    }

    return supports;
};

export const appIsHydrated = (): boolean => {
    if (!isBrowser()) {
        return false;
    }

    return window.APP_IS_HYDRATED === true;
};

export const isInSweden = (): boolean => typeof Modernizr !== 'undefined' && Modernizr.sweden === true;

export const isTouchDevice = (): boolean =>
    typeof Modernizr !== 'undefined' && Modernizr.touchevents === true;
